import React from 'react';
import { withStyles, Theme } from '@material-ui/core/styles';
import Bread from '@material-ui/core/Breadcrumbs';
import Chip from '@material-ui/core/Chip';
import Link from '@material-ui/core/Link';
import styled from 'styled-components';

const StyledBreadcrumb = withStyles((theme: Theme) => ({
  root: {
    backgroundColor: '#E5E3E3',
    height: theme.spacing(3),
    fontWeight: 'bolder',
    fontFamily: 'Roboto',
    fontSize: '12px',
    color: '#2B2727',
    '&:hover, &:focus': {
      backgroundColor: theme.palette.grey[300],
    },
  },
}))(Chip) as typeof Chip;

const StaledBreadcrumbs = styled(Bread)`
   {
    position: absolute;
    top: -60px;
  }
  .link {
    font-weight: bolder;
    font-family: Roboto;
    font-size: 12px;
    color: #8b8b8b;
  }
`;

export interface CustomizedBreadcrumbsProps {
  claimStatus: string;
  claimNumber: string;
}

const CustomizedBreadcrumbs: React.FC<CustomizedBreadcrumbsProps> = (
  props,
): JSX.Element => {
  return (
    <StaledBreadcrumbs aria-label="breadcrumb">
      <StyledBreadcrumb component="a" href="#" label="Accueil" />
      <Link className="link" color="inherit">
        <span className="link">{props.claimStatus}</span>
      </Link>
      <Link color="inherit">
        <span className="link">{props.claimNumber}</span>
      </Link>
    </StaledBreadcrumbs>
  );
};
export default CustomizedBreadcrumbs;
